import { useEffect, useState } from "react";
import { Activity, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export const UserPositionsPanel = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/me/positions");
      setRows(data);
    } catch {
      /* silent */
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    const iv = setInterval(load, 30000);
    return () => clearInterval(iv);
  }, []);

  const open = rows.filter((r) => r.status === "ACIK");
  const closed = rows.filter((r) => r.status !== "ACIK");

  return (
    <div data-testid="user-positions-panel" className="rounded-2xl border" style={{ background: "var(--bg-card)", borderColor: "var(--border-subtle)" }}>
      <div className="px-5 sm:px-6 py-4 border-b flex items-center gap-2" style={{ borderColor: "var(--border-subtle)" }}>
        <Activity className="w-4 h-4 text-emerald-400" />
        <h3 className="text-sm font-bold">Pozisyonlarım (BingX)</h3>
        <span className="ml-auto text-[11px]" style={{ color: "var(--text-muted)" }}>{open.length} açık</span>
      </div>
      <div className="px-3 sm:px-4 py-3">
        {loading ? (
          <div className="flex items-center justify-center py-6"><Loader2 className="w-5 h-5 animate-spin text-blue-500" /></div>
        ) : rows.length === 0 ? (
          <div className="text-center py-6 text-sm" style={{ color: "var(--text-muted)" }}>Henüz işlem açmadınız</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-[10px] uppercase tracking-wider" style={{ color: "var(--text-muted)" }}>
                  <th className="text-left px-2 py-2">Coin</th>
                  <th className="text-left px-2 py-2">Yön</th>
                  <th className="text-left px-2 py-2">Ort. Giriş</th>
                  <th className="text-left px-2 py-2">TP1</th>
                  <th className="text-left px-2 py-2">DCA</th>
                  <th className="text-left px-2 py-2">Durum</th>
                </tr>
              </thead>
              <tbody>
                {[...open, ...closed].map((r) => (
                  <tr key={r.id} data-testid={`my-position-${r.id}`} className="border-t" style={{ borderColor: "var(--border-subtle)" }}>
                    <td className="px-2 py-2 font-semibold">{r.coin}</td>
                    <td className="px-2 py-2">
                      <span className="text-[11px] font-semibold" style={{ color: r.direction === "LONG" ? "#10B981" : "#EF4444" }}>{r.direction}</span>
                    </td>
                    <td className="px-2 py-2 font-mono-term">{r.avg_entry}</td>
                    <td className="px-2 py-2 font-mono-term">{r.tp1 || "—"}</td>
                    <td className="px-2 py-2">{r.dca_level}/{r.max_dca}</td>
                    <td className="px-2 py-2">
                      {r.status === "ACIK"
                        ? <span className="text-[11px] font-semibold" style={{ color: "#10B981" }}>Açık</span>
                        : <span className="text-[11px]" style={{ color: "var(--text-muted)" }}>Kapandı{r.realized_pnl ? ` · ${Number(r.realized_pnl).toFixed(2)}` : ""}</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
